module.exports = __webpack_public_path__ + "img/流体力学5_3_4.9309fb74.jpg";